<template>
    <div class="interiorzone">
        <div class="toptit"><h2 class=" fl subheading">推荐人管理</h2></div>
        <div class="tabbox">
            <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    width="180"
                    label="序号"
                    >
                </el-table-column>
                <el-table-column
                    prop="name"
                    width="180"
                    label="创建时间"
                    >
                </el-table-column>
                <el-table-column
                    prop="name"
                    width="180"
                    label="姓名"
                    >
                </el-table-column>
                <el-table-column
                    prop="name"
                    width="180"
                    label="手机号"
                    >
                </el-table-column>
                <el-table-column
                    prop="name"
                    width="180"
                    label="推荐码"
                    >
                </el-table-column>
                <el-table-column
                    prop="value"
                    label="累计贴现票面金额(元)"
                    >
                </el-table-column>
                <el-table-column
                    prop="desc"
                    label="累计分润金额(元)"
                    >
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="80">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">查看更多</el-button>
                        </template>
                </el-table-column>
            </el-table>

            <div class="pagebox">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page='currentPage'
                    :page-size='pageSize'
                    @current-change='changeCurrent'
                    :total="1000">
                </el-pagination>
            </div>

            <el-dialog
                title="内容修改"
                :visible.sync="shows"
                width="400px"
                :close-on-click-modal='false'
                >
                <div>
                    <div class="demo-input-suffix">
                        参数名字:
                        <el-input
                            placeholder="请输入内容"
                            v-model="names">
                        </el-input>
                    </div>
                    <div class="demo-input-suffix">
                        参数值：
                        <el-input
                            placeholder="请输入内容"
                            v-model="vals">
                        </el-input>
                    </div>
                    <div class="demo-input-suffix">
                        参数说明：
                        <el-input
                            placeholder="请输入内容"
                            v-model="decs">
                        </el-input>
                    </div>
                    <div class="gogo">
                        <el-button class="trueChange" @click="changeClick" type="primary">确认修改</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            tableData: [],
            currentPage:1,
            pageSize:10,
            shows:false,
            adjson:{},
            names:'',
            vals:'',
            decs:''
        }
    },
    mounted(){
        this.handleAjax()
    },
    methods:{
        handleClick(val){
            this.adjson=val
            this.names=val.name
            this.vals=val.value
            this.decs=val.desc
            this.shows=!this.shows
        },
        changeClick(){
            this.ajax.post('/system/updatesystem',{bizContent:{name:this.names,value:this.vals}})
            .then(
                result=>{
                    if(result.data.status=='0000'){
                        swal({
                            text: '修改成功！',
                            timer: 3000,
                            buttons: false
                        })
                        this.shows=false
                        this.handleAjax()
                    }
                    else{
                        swal({
                            text: result.data.message,
                            timer: 3000,
                            buttons: false
                        })
                    }
                    }
            )
        },
        handleAjax(){
            this.ajax.post('/system/getallsystem',{bizContent:{pageSize:this.pageSize,currentPage:this.currentPage}})
            .then(
                result=>{
                    if(result.data.status=='0000'){
                        this.tableData=result.data.data.responseList
                        console.log(this.tableData,'sssssssss')
                    }
                    else{
                        swal({
                            text: result.data.message,
                            timer: 3000,
                            buttons: false
                        })
                    }
                    }
            )
        },
        changeCurrent(val){

        }
    }
}
</script>

<style  scoped>
.toptit{
  width:100%;
  display:table;
  clear:both;
  margin-bottom:20px;
}
.gogo{
    text-align: center;
}
.trueChange{
    margin: auto;
    margin-top: 15px;
}
.pagebox{
    width: 100%;
    margin-top: 15px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/recom.vue